package app.nestbridge.app.usecase

import app.nestbridge.app.context.identity.UserContextProvider
import me.tatarka.inject.annotations.Inject

@Inject
class ClearUserContextUseCase(
    private val userContextProvider: UserContextProvider,
) {
    suspend operator fun invoke() {
        userContextProvider.clear()
    }
}
